import React from "react";
import { Card, Table, Typography, Skeleton } from "antd";
import { Title } from "components/common";
import { getTimeDateString } from "utils/date";
import styles from "./DashboardQuizzes.module.less";

const { Text } = Typography;

const QuizzesSkeleton = () => (
  <Card className={styles.sectionCard}>
    <div className={styles.sectionHeader}>
      <Skeleton.Input active size="small" className={styles.skeletonTitle} />
    </div>
    <div className={styles.skeletonTableWrap}>
      <div className={styles.skeletonTableHeader}>
        <Skeleton.Input active size="small" className={styles.skeletonTableTh} />
        <Skeleton.Input active size="small" className={styles.skeletonTableTh} />
        <Skeleton.Input active size="small" className={styles.skeletonTableTh} />
      </div>
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className={styles.skeletonTableRow}>
          <Skeleton.Input active size="small" className={styles.skeletonTableTd} />
          <Skeleton.Input active size="small" className={styles.skeletonTableTd} />
          <Skeleton.Input active size="small" className={styles.skeletonTableTd} />
        </div>
      ))}
    </div>
  </Card>
);

const latestQuizzesColumns = [
  {
    title: "Quiz",
    dataIndex: "quizScriptName",
    key: "quizScriptName",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (date) => (date ? getTimeDateString(date, false, true) : "—"),
  },
  {
    title: "Accuracy",
    dataIndex: "accuracy",
    key: "accuracy",
    render: (acc) => `${acc ?? "0"}%`,
  },
];

const DashboardQuizzes = ({ latestQuizzes = [], loading, isFetching }) => {
  if (loading) return <QuizzesSkeleton />;

  return (
    <Card className={styles.sectionCard}>
      <div className={styles.cardContentWrap}>
        <div className={styles.sectionHeader}>
          <Title level={5} className={styles.sectionTitle}>
            Latest Quizzes
          </Title>
        </div>
        <Card bordered className={styles.tableCard}>
            <Table
              columns={latestQuizzesColumns}
              dataSource={latestQuizzes}
              rowKey={(_, i) => i}
              pagination={false}
              size="small"
              loading={false}
              locale={{ emptyText: "No quizzes yet" }}
            />
        </Card>
        {isFetching && <div className={styles.shimmerOverlay} />}
      </div>
    </Card>
  );
};

export default DashboardQuizzes;
